import { ref, readonly } from 'vue'

/**
 * アラートメッセージを更新し、フラグ(hasError)を立てる。
 * @param argMessage エラーメッセージ
 */
export const useAlertMessage = () => {
  const message = ref('')
  const hasError = ref(false)

  /**
   * アラート(hasError)のフラグを追加する。
   */
  const addAlertMessage = (argMessage: string): void => {
    message.value = argMessage
    hasError.value = true
  }

  /**
   * アラート(hasError)のフラグを降ろす。
   */
  const deleteAlertMessage = (): void => {
    message.value = ''
    hasError.value = false
  }

  return {
    message: readonly(message),
    hasError: readonly(hasError),
    addAlertMessage,
    deleteAlertMessage
  }
}
